<template>
  <div align="left">
    <p>
      <el-button type="primary" icon="el-icon-circle-plus" :loading="verifying" @click="openDialog">核销</el-button>
    </p>
    <el-table
      :data="tableData"
      border
      style="width: 100%">
      <el-table-column
        prop="year"
        label="年份"
        width="120">
      </el-table-column>
      <el-table-column
        prop="weight"
        label="总重量（公斤）"
        width="120">
        <template slot-scope="scope">
          {{toFixed2(scope.row.weight/1000)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="总金额（元）"
        width="140">
        <template slot-scope="scope">
          {{toFixed2(scope.row.amount/100)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="last_balance"
        label="上年度结余（元）"
        width="140">
        <template slot-scope="scope">
          {{toFixed2(scope.row.last_balance/100)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="deposit"
        label="本年度充值（元）"
        width="140">
        <template slot-scope="scope">
          {{toFixed2(scope.row.deposit/100)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="balance"
        label="本年度结余（元）"
        width="140">
        <template slot-scope="scope">
          {{toFixed2(scope.row.balance/100)}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="140">
        <template slot-scope="scope">
          <el-button type="danger" size="small" @click="cancelVerification(scope.row.year)">取消核销</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="核销" :visible.sync="dialogVisible">
      <el-form :model="form">
        <el-form-item label="年份" label-width="120px">
          <el-input v-model="form.year" placeholder="请输入年份，如2025"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="verifying">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import coder from "./enum.js"
export default {
  methods: {
    load(){
      window.ws.Call("W2S_VerificationList");
    },
    toFixed2(val){
      let num=(Math.trunc(val*100)/100).toFixed(2).split('.');
      num[0]=num[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return num.join('.');
    },
    openDialog(){
      this.form.year='';
      this.dialogVisible=true;
    },
    submit(){
      let year=this.form.year.trim();
      if (year===''||!/^\d{4}$/.test(year)){
        this.$alert('请输入正确的年份', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.verifying){ return }
      this.verifying=true;
      let $this=this;
      window.ws.AddFunc("S2W_VerificationRes",function (code,err) {
        $this.verifying=false;
        if (code===coder.OK){
          $this.$notify({
            title: '成功',
            message: '核销成功',
            type: 'success'
          });
          $this.dialogVisible=false;
          $this.load();
        }else{
          $this.$alert(err+'('+code+')', '错误', {
            confirmButtonText: '确定'
          });
        }
      });
      window.ws.Call("W2S_Verification", year);
    },
    cancelVerification(year){
      let $this=this;
      this.$confirm('确定取消 '+year+' 年的核销吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        window.ws.AddFunc("S2W_CancelVerificationRes",function (code,err) {
          if (code===coder.OK){
            $this.$notify({
              title: '成功',
              message: '取消核销成功',
              type: 'success'
            });
            $this.load();
          }else{
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }
        });
        window.ws.Call("W2S_CancelVerification", year);
      }).catch(()=>{});
    }
  },
  mounted() {
    let $this=this;
    window.ws.AddFunc("S2W_VerificationListRes",function (code,err,list) {
      console.log("S2W_VerificationListRes:",code,err,list);
      if (code===coder.OK){
        $this.tableData=(list||[]).slice().sort(function(a,b){return Number(b.year)-Number(a.year)});
      }else{
        $this.$alert(err+'('+code+')', '错误', {
          confirmButtonText: '确定'
        });
      }
    });
    this.load();
  },
  data() {
    return {
      dialogVisible:false,
      verifying:false,
      form: {
        year:''
      },
      tableData:[]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/Verification.vue